// extracted by mini-css-extract-plugin
export default {"bord":"index_bord_mjR3J","tit":"index_tit_-ledV","p10":"index_p10_f4Kcb","listItem":"index_listItem_Ux-OS","cRed3":"index_cRed3_upuoh","cBlue":"index_cBlue_IQ-vD"};